export default {
  modalTitle: 'Mise à jour des conditions d’utilisation',
  acceptButton: 'Accepter',
  declineButton: 'Refuser',
  language: 'Langue d’affichage',
};
